import { ArcBaseContent } from '@src/core/components';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectSelectedHistoryOrder } from '../../../redux';
import { ArcButton, ArcStack, ArcText } from '@src/core/ui';
import { ArcGoogleMap } from '@src/core/controllers';
import { Route, Routes } from 'react-router-dom';
import HistoryMap from './map';
import { MissionDetailsGrid } from '@src/features/order/pages/orders-page/components';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useRepeatOrder } from '@src/features/order/hooks';
import { useUnitType } from '@src/core/features/settings';


export const HistoryOrdersContent: React.FC = () => {
  const order = useSelector(selectSelectedHistoryOrder);
  // Subscribe so altitude/speed/distance values (arcSpatium/arcVelocitas) re-render
  // on a live unit switch (UNITS Standard R1).
  useUnitType();

  const repeatOrder = useRepeatOrder();
  const onRepeat = () => repeatOrder(order);


  return (
    <ArcBaseContent>
      <ArcStack
        py={3}
        px={5}
        paddingTop={2}
        width="100%"
        height="100%"
        spacing={2}
        sx={{ minHeight: 0, overflow: 'hidden' }}
      >

        <ArcStack direction="row" alignItems="center" justifyContent="space-between" flexShrink={0}>
          <ArcText.h3 fontWeight={500}>MISSION DETAILS</ArcText.h3>
          <ArcButton.brand
            onClick={onRepeat}
            endIcon={<RefreshIcon sx={{ color: 'common.black' }} />}
            sx={{ textTransform: 'none', padding: '4px 8px', fontSize: '12px', '& .MuiTypography-root': { textTransform: 'none' } }}>
            Repeat
          </ArcButton.brand>
        </ArcStack>

        <ArcStack direction="row" spacing={1} sx={{ flex: 1, minHeight: 0 }}>
          <ArcStack
            p='10px 35px'
            borderRadius={1}
            bgcolor="background.paper"
            width="50%"
            sx={{ minHeight: 0, overflowY: 'auto' }}
          >
            <ArcStack sx={{ marginTop: 1, marginBottom: 1 }}>
              <MissionDetailsGrid order={order ?? undefined} variant='detailed' />
            </ArcStack>
          </ArcStack>
          <ArcStack width="50%" height="100%" borderRadius={1} sx={{ minHeight: 0, overflow: 'hidden' }}>
            <ArcGoogleMap hideToolbar hideMapControls>
              <Routes>
                <Route index element={<HistoryMap />} />
              </Routes>
            </ArcGoogleMap>
          </ArcStack>
        </ArcStack>
      </ArcStack>
    </ArcBaseContent>
  );
};
